import { ATSPrincipalAppCandidatesListTestIds } from 'data-testids/ATS';
import { StyledHeaderTableCell } from '../styles';
import { TableHead, TableRow, useTheme } from '@mui/material';

export const CandidatesListTableHeader = () => {
  const theme = useTheme();

  return (
    <TableHead
      sx={{
        backgroundColor: theme.palette.gray.lightest,
      }}
    >
      <TableRow>
        <StyledHeaderTableCell
          data-testid={ATSPrincipalAppCandidatesListTestIds.CANDIDATE_DETAILS_COLUMN}
          align="left"
        >
          Candidate
        </StyledHeaderTableCell>
        <StyledHeaderTableCell
          data-testid={ATSPrincipalAppCandidatesListTestIds.JOB_DETAILS_COLUMN}
          align="left"
        >
          Job
        </StyledHeaderTableCell>
        <StyledHeaderTableCell
          align="left"
          data-testid={ATSPrincipalAppCandidatesListTestIds.DETAILS_COLUMN}
        >
          Application Details
        </StyledHeaderTableCell>
        <StyledHeaderTableCell
          data-testid={ATSPrincipalAppCandidatesListTestIds.ACTIONS_COLUMN}
          sx={{ paddingLeft: theme.spacing(4) }}
        >
          Actions
        </StyledHeaderTableCell>
      </TableRow>
    </TableHead>
  );
};
